import React from 'react';

const TEXTER = {
  max_tokens: 'Svaret avbröts eftersom det blev för långt.',
  max_rounds: 'KanAI nådde gränsen för antal arbetssteg och avslutade svaret.',
  refusal: 'KanAI avböjde att besvara den här frågan.',
  cancelled: 'Du stoppade svaret.',
  incomplete: 'Anslutningen bröts innan svaret var klart.',
};

export const FORTSATT_PROMPT = 'Fortsätt exakt där du slutade, utan att upprepa det som redan står.';

/**
 * KanAIStoppedNotice — notis under ett svar som inte blev klart, med
 * knappen "Fortsätt" där det går att be om resten. Tidigare visades ett
 * avklippt svar som ett vanligt, färdigt svar (2026-10-14).
 *
 * @param {object} props
 * @param {string} props.reason - max_tokens | max_rounds | refusal | cancelled | incomplete
 * @param {function} [props.onContinue] - skickar fortsättningsfrågan
 * @param {boolean} [props.disabled] - medan ett annat svar strömmar
 */
export default function KanAIStoppedNotice({ reason, onContinue, disabled }) {
  const text = TEXTER[reason];
  if (!text) return null;
  const kanFortsatta = Boolean(onContinue) && (reason === 'max_tokens' || reason === 'max_rounds' || reason === 'cancelled' || reason === 'incomplete');
  const neutral = reason === 'cancelled';
  return (
    <div className={'kp-kanai-stopped' + (neutral ? ' kp-kanai-stopped--neutral' : '')} role="status">
      <span>{text}</span>
      {kanFortsatta && (
        <button
          type="button"
          className="kp-kanai-stopped__btn"
          disabled={disabled}
          onClick={() => onContinue(FORTSATT_PROMPT)}
        >
          Fortsätt
        </button>
      )}
    </div>
  );
}
